import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { DateRangeISO } from "interfaces/DateRange";

const base = "TRACK_OPTICS_PAGE";

export const SET_SELECTED_DATE_RANGE = `${base}_SET_SELECTED_DATE_RANGE`;
export const SET_SELECTED_FACILITY = `${base}_SET_SELECTED_FACILITY`;

export interface TrackOpticsPageType {
  type: string;
  selectedFacility: racehorse360.IFacility;
  selectedDateRange: DateRangeISO;
}

export const setSelectedDateRange = (
  selectedDateRange: DateRangeISO
): Partial<TrackOpticsPageType> => {
  return {
    type: SET_SELECTED_DATE_RANGE,
    selectedDateRange
  };
};

export const setSelectedFacility = (
  selectedFacility: racehorse360.IFacility
): Partial<TrackOpticsPageType> => {
  return {
    type: SET_SELECTED_FACILITY,
    selectedFacility
  };
};
